<header class="alt-header">
    <div class="container-fluid">
        <div class="header-inner">
            <div class="company-logo">
                <a href="#">
                    <img src="{{pageHeaderResponseJSON.uploadedLeftLogoPath}}" *ngIf="uploadedLeftLogoVisible" alt="peoplestrong logo">
                 </a>
            </div>
            <div class="business-logo">
                <a href="#">
                   <img src="{{pageHeaderResponseJSON.uploadedRightLogoPath}}" *ngIf="uploadedRightLogoVisible" alt="business logo">
                </a>
            </div>
        </div>
    </div>
</header>
<!-- \\ End Site Header -->
<!-- Section Main Templet -->

<section class="alt-banner">
    <img src="{{pageHeaderResponseJSON.uploadedLogoPath}}" *ngIf="bannerImageVisible" alt="Banner image">
    <div class="banner-heading">{{pageHeaderResponseJSON.pageHeader}}</div>
</section>